import React from 'react';
import './GridPage.css';
import gridLogo from "../../assets/Grow Together Logo.jpg";
import CommunityGarden from "../../assets/CommunityGarden.png";
import CommunityNeighbors from "../../assets/CommunityNeighbors.png";
import SharingHands from "../../assets/SharingHands.png";
import SmallHarvest from "../../assets/SmallHarvest.jpg";
import FamilyWorking2 from "../../assets/FamilyWorking2.jpg";
import GardenShot from "../../assets/GardenShot.png";

function GridPage({ onNavigate }) {
  const gridItems = [
    {
      id: 1,
      title: "1. Who/Our Story",
      image: CommunityGarden,
    },
    {
      id: 2,
      title: "2. About",
      image: CommunityNeighbors,
    },
    {
      id: 3,
      title: "3. Previously received funds",
      image: SharingHands,
    },
    {
      id: 4,
      title: "4. Media",
      images: [SmallHarvest, FamilyWorking2, GardenShot],
    },
  ];

  return (
    <div className="grid-page-container">
      <div className="grid-page-header">
        <img src={gridLogo} alt="Grow Together Logo" className="grid-page-logo" />
        <button className="nav-button" onClick={() => onNavigate('main')}>
          ← Back to Main
        </button>
      </div>

      <div className="grid-container">
        {gridItems.map((item) => (
          <div key={item.id} className="grid-card">
            <div className="card-image-container">
              {item.images ? (
                <div className="multi-image-container">
                  {item.images.map((img, idx) => (
                    <img key={idx} src={img} alt={`${item.title} ${idx + 1}`} />
                  ))}
                </div>
              ) : (
                <img src={item.image} alt={item.title} />
              )}
            </div>
            <div className="card-content">
              <h2>{item.title}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GridPage;
